export default __webpack_public_path__ + "static/media/Group784.8acb70e0.svg";